import { GET_LOGIN, GET_OTP, GET_PROFILE, GET_ADDMAGICTOKEN, GET_VERIFYMAGICTOKEN, GET_COUNTRYCODE } from "../../resources/actionTypes";

const initialState = {
  userLogin: [],
  userProfile: {},
  loading: false,
  otpLoader: false,
  error: null,
};

const initialAddMagicToken = {
  loading: false,
  error: null,
  addMagicToken: ""
};

const initialVerifyMagicToken = {
  loading: false,
  error: null,
  addMagicToken: ""
};

const initialStateCountryCode = {
  countryCodeList: [],
  loading: false,
  error: null,
};

export const auth = (state = initialState, action) => {
  switch (action.type) {
    case GET_LOGIN.GET_LOGIN_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_LOGIN.GET_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        userLogin: action.userLogin,
      };
    case GET_LOGIN.GET_LOGIN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    case GET_OTP.GET_OTP_REQUESTED:
      return {
        ...state,
        otpLoader: true,
        isAuth: false,
      };
    case GET_OTP.GET_OTP_SUCCESS:
      return {
        ...state,
        otpLoader: false,
        isAuth: true,
        userOtp: action.userOtp,
      };
    case GET_OTP.GET_OTP_FAILED:
      return {
        ...state,
        otpLoader: false,
        isAuth: false,
        error: action.message,
      };
      case GET_PROFILE.GET_PROFILE_REQUESTED:
        return {
          ...state,
          loading: true,
          isAuth: false,
        };
      case GET_PROFILE.GET_PROFILE_SUCCESS:
        return {
          ...state,
          loading: false,
          isAuth: true,
          userProfile: action.userProfile,
        };
      case GET_PROFILE.GET_PROFILE_FAILED:
        return {
          ...state,
          loading: false,
          isAuth: false,
          error: action.message,
        };
  
    default:
      return state;
  }
};

export const addMagicToken = (state = initialAddMagicToken, action) => {
  switch (action.type) {
    case GET_ADDMAGICTOKEN.GET_ADDMAGICTOKEN_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDMAGICTOKEN.GET_ADDMAGICTOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        initialAddMagicToken: action.addMagicToken
      };
    case GET_ADDMAGICTOKEN.GET_ADDMAGICTOKEN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const verifyMagicToken = (state = initialVerifyMagicToken, action) => {
  switch (action.type) {
    case GET_VERIFYMAGICTOKEN.GET_VERIFYMAGICTOKEN_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_VERIFYMAGICTOKEN.GET_VERIFYMAGICTOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        initialVerifyMagicToken: action.initialVerifyMagicToken
      };
    case GET_VERIFYMAGICTOKEN.GET_VERIFYMAGICTOKEN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export function getCountryCode(state = initialStateCountryCode, action) {
  switch (action.type) {
    case GET_COUNTRYCODE.GET_COUNTRYCODE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_COUNTRYCODE.GET_COUNTRYCODE_SUCCESS:
      return {
        ...state,
        loading: false,
        countryCodeList: action.countryCodeList
      };
    case GET_COUNTRYCODE.GET_COUNTRYCODE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}